// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".enduser-chat-fill-info {\n  font-size: 20px;\n  margin: 0 0 20px 0;\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://src/app/shared/components/NotLoginEndUserChatBox/EndUserForm/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".enduser-chat-fill-info {\n  font-size: 20px;\n  margin: 0 0 20px 0;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
